import { Component, OnInit } from '@angular/core';
import { MemberResponseInterface } from '@careapp/angular-sdk';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as actions from '../store/actions/index';
import * as selectors from '../store/reducers/index';

@Component({
  selector: 'sd-profile',
  templateUrl: 'profile.component.html',
  styleUrls: ['profile.component.scss']
})
export class ProfileComponent implements OnInit {
  profile: Observable<MemberResponseInterface>;

  constructor(public store: Store<any>) {}

  ngOnInit() {
    this.store.dispatch(new actions.RequestUpdatedProfileAction());
    this.profile = this.store.select(selectors.auth.getLoggedInUser);
  }

  save(event) {
    this.store.dispatch(new actions.RequestSaveProfileAction(event));
  }
}
